export default "__VITE_ASSET__Bi6y5rIN__"